import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { KonvasComponent } from "../../component/konvas/konvas.component";
import { NgForOf, NgIf, NgStyle } from "@angular/common";
import { ConfigService } from "../../common/service/config.service";
import { CommonComponent } from "../../common/common-component";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { Modal, ModalOptions } from "flowbite";
import { ContentBlockComponent } from "../../component/content-block/content-block.component";

@Component({
  selector: 'section#home',
  standalone: true,
  imports: [
    FaIconComponent,
    KonvasComponent,
    NgForOf,
    NgIf,
    RouterLink,
    ReactiveFormsModule,
    ContentBlockComponent,
    NgStyle
  ],
  templateUrl: './home.component.html'
})
export class HomeComponent extends CommonComponent implements OnInit {

  @ViewChild('modal') modal!: ElementRef;

  public lastTouch: any;
  public openSetupCount: number = 0;
  public boothMode: boolean = false;
  public submitted: boolean = false;
  public form!: FormGroup;

  private modalInstance: Modal | undefined;

  constructor(
    private configService: ConfigService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject('Storage') protected storage: Storage
  ) {
    super();
    this.boothMode = this.storage.getItem('forceBoothMode') === 'true';
  }

  ngOnInit(): void {

    this.storage.removeItem('user_config');

    this.configService.config$.subscribe((config) => {
      this.config = config;
    });

    this.form = new FormGroup({
      'agree': new FormControl(null, [Validators.requiredTrue])
    });
  }


  onSubmit() {
    this.submitted = true;

    if(this.form.valid) {
      this.goToNextPage();
    }
  }

  termsModal() {

    const options: ModalOptions = {
      placement: 'bottom-right',
      backdrop: 'dynamic',
      backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40',
      closable: true
    };

    this.modalInstance = new Modal(this.modal.nativeElement, options);

    this.modalInstance.show();

    return false;
  }

  dismiss() {
    if(this.modalInstance) {
      this.modalInstance.hide();
    }
  }

  goToNextPage() {
    if(this.config && this.config.enableSelection) {
      this.router.navigate([ '..', 'choose' ], { relativeTo: this.route }).then();
    }
    else if(this.config && this.config.enableGenerationSelection) {
      this.router.navigate([ '..', 'themes' ], { relativeTo: this.route }).then();
    }
    else {
      this.router.navigate([ '..', 'capture' ], { relativeTo: this.route }).then();
    }
  }

  @HostListener('document:click', [ '$event' ])
  public configTrigger(event: MouseEvent): void {

    this.lastTouch = Date.now();

    if (event.pageX < 100 && event.pageY < 100) {
      this.openSetupCount++;
    } else {
      this.openSetupCount = 0;
    }

    if (this.openSetupCount > 2) {
      console.log('open setup');
      this.openSetupCount = 0;
      this.router.navigate([ '..', 'config' ], { relativeTo: this.route }).then();
    }
  }
}
